<template>
    <div>
        <error-dialog ref="errorDialog" @onUserConfirmation="dataTransmissionError()"/>
        <outcome-task
            v-if="outcomeTaskScenarioInstance"
            :item="item"
            :instance="outcomeTaskInstance"
            :scenario="outcomeTaskScenario"
            :scenarioInstance="outcomeTaskScenarioInstance"
            :rounds="rounds"
            :locale="locale"
            @select="setAnswer"
        />
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ItemsContainerMixin from '@/containers/Items/mixins/ItemsContainerMixin'

import outcomeTaskItem from '@/components/items/outcomeTaskItem'
import errorDialog from '@/components/ui/errorDialog'

export default {
    name: 'OutcomeTaskContainer',
    components: {
        'outcome-task': outcomeTaskItem,
        'error-dialog': errorDialog,
    },
    mixins: [ItemsContainerMixin],
    props: {
        interactionInstanceToken: {
            type: String
        },
        item: {
            type: Object
        },
        nextClicked: {
            type: Boolean
        },
    },
    computed: {
        ...mapGetters([
            'instanceToken',
            'outcomeTaskInstance',
            'outcomeTaskScenario',
            'outcomeTaskScenarioInstance',
            'requestError',
            'locale',
        ]),
        rounds() {
            const offset = parseInt(this.itemProperties.getProperty('scenario_offset')) || 0
            const total = this.itemProperties.getProperty('total_rounds')
            const number = this.outcomeTaskScenarioInstance.round + offset

            return {
                number,
                total
            }
        }
    },
    watch: {
        item() {
            this.openCurrentItem()
            this.initOutcomeTask()
        },
        nextClicked(newVal) {
            if(newVal) {
                this.handleNext()
            }
        }
    },
    methods: {
        ...mapActions([
            'openItem',
            'startOutcomeTask',
            'fetchOutcomeTaskData',
            'answerOutcomeTask',
        ]),
        openCurrentItem() {
            const interactionInstanceToken = this.instanceToken
            const itemId = this.item.itemId
            const timeStamp = new Date().getTime()

            this.openItem({ interactionInstanceToken, itemId, timeStamp })
        },
        async initOutcomeTask() {
            await this.startOutcomeTask({
                interactionInstanceToken: this.instanceToken,
                itemId: this.item.itemId
            })

            this.fetchOutcomeTaskData({
                interactionInstanceToken: this.instanceToken,
                itemId: this.item.itemId
            })
        },
        setAnswer(result) {
            this.currentAnswer = result
            this.$emit('answer', true)
        },
        async handleNext() {
            await this.answerOutcomeTask({
                interactionInstanceToken: this.instanceToken,
                itemId: this.item.itemId,
                answer: this.currentAnswer
            })

            if (this.requestError == null){
              this.$emit('answered')
            } else {
              this.$refs.errorDialog.show();
            }
        },
        dataTransmissionError() {
          this.$emit('resetAfterDataTransmissionError');
        },
    },
    mounted() {
        // send item open call when the container is being mounted, this fixes an issue where we were
        // missing item open events, for the first item in a sequence / section. This happens because
        // the item() watcher defined above, is only triggered when an item changes, but this is not
        // the case on the initial rendering of the container
        if(!this.item.opened) {
          this.openCurrentItem()
        }

        this.initOutcomeTask()
    }
}
</script>
